import React from 'react'

export default function BASICExamDateAssignments() {
    return <div>BASIC Exam Date Assignments</div>
}
